/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Accordion } from "react-bootstrap";
import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";
import L from "../Lang";
import ItemMenuManager from "./ItemMenu/ItemMenuManager";

export default class ItemMenu extends BaseCom {

    async componentDidMount() {

    }

    properties(col, state, changeStateValue, onChange) {
        return (<>
            <ItemMenuManager
                col={col}
                show={state.showItemMenuManager}
                onSubmit={() => {
                    changeStateValue('showItemMenuManager', false);
                    onChange();
                }}
                initialProps={state.initialProps}
            />
            <Accordion.Item eventKey="-1">
                <Accordion.Header><L>Item Menu</L></Accordion.Header>
                <Accordion.Body>
                    <div className="d-flex gap-1 justify-content-evenly">
                        <button type="button" className="btn btn-primary d-block" onClick={() => {
                            changeStateValue('showItemMenuManager', true);
                            changeStateValue('initialProps', col.extendedProps);
                        }}>
                            <L>Item Menu Manager</L>
                        </button>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </>
        );
    }

    render() {

        return (
            <div className={'text-center p-4 bg-light ' + this.props.col.className}
                style={Globals.preprocessStyleObject(this.props.col.style)}>

                <div className="list-group">
                    {this.props.col.extendedProps?.list?.map((i, idx) => (
                        <div key={idx} className="list-group-item d-flex gap-1 justify-content-between">
                            <div className="flex-grow">{i.name}</div>
                            <div>{Globals.tryFormatPrice(i.price)}</div>
                        </div>
                    ))}
                </div>


            </div>
        );
    }
}